
import { GenericEntityBase, KeyType } from "../../_models/GenericEntityBase";
import { IPropretyAttribute, IEntityMetaData } from "../../_models/IEntityMetaData";
import { PropretyAttributes, Validation, NavigationProperty } from "../../decorators/EntityDecorators";
import { i18nLabel } from "./i18nLabel.model";

export class i18nFeature extends GenericEntityBase<number> {
  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.KeyProperty,
      IPropretyAttribute.Readonly
    ]
  })
  id: number = GenericEntityBase.GetDefaultId(KeyType.number);

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  @Validation({ maxLength: 50 })
  featureID!: string;

  @NavigationProperty({ TargetType: i18nLabel })
  i18nLabels?: i18nLabel[];

  GetType(): IEntityMetaData {
    return i18nFeature.getMetaData();
  }
}
